// MODULES
import { useNavigate } from "react-router-dom";
import { useState } from "react";
// COMPONENTS
import Navbar from "../../components/app/Navbar";
import Wallet from "../../components/profile/wallet";
import History from "../../components/profile/history";
// IMAGES
import back from "../../assets/back.png";
import walletPrimary from "../../assets/wallet-primary.png";
import walletGray from "../../assets/wallet-gray.png";
import historyPrimary from "../../assets/history-primary.png";
import historyGray from "../../assets/history-gray.png";
import referralsGray from "../../assets/profile-gray.png";
import referralsPrimary from "../../assets/profile-primary.png";

export default function Profile() {
  const [page, setPage] = useState("wallet");
  const navigate = useNavigate();
  return (
    <div>
      <div>
        <Navbar />
      </div>
      <div className="lg:grid grid-cols-3 gap-5 px-6 lg:px-16 py-6 lg:py-14 max-lg:space-y-7">
        <div>
          <div onClick={() => navigate(-1)}>
            <div className="flex items-center py-5 space-x-2 cursor-pointer">
              <img src={back} alt="" className="w-5" />
              <h1 className="font-medium text-lg">Back</h1>
            </div>
          </div>
          <div className="border border-border rounded-lg p-4 max-lg:flex max-lg:items-center max-lg:justify-evenly">
            <div
              onClick={() => setPage("wallet")}
              className={`flex items-center space-x-[5px] md:space-x-3 cursor-pointer py-3 ${
                page === "wallet"
                  ? "text-primary font-semibold"
                  : "hover:text-primary text-themeGray"
              }`}
            >
              <div>
                {page === "wallet" ? (
                  <img
                    className="w-5 h-5 md:w-6 md:h-6"
                    src={walletPrimary}
                    alt=""
                  />
                ) : (
                  <img
                    className="w-5 h-5 md:w-6 md:h-6"
                    src={walletGray}
                    alt=""
                  />
                )}
              </div>
              <div>
                <h1 className="text-base md:text-[20px]">Wallet</h1>
              </div>
            </div>
            <div
              onClick={() => setPage("history")}
              className={`flex items-center space-x-[5px] md:space-x-3 cursor-pointer py-3 ${
                page === "history"
                  ? "text-primary font-semibold"
                  : "hover:text-primary text-themeGray font-medium"
              }`}
            >
              <div>
                {page === "history" ? (
                  <img
                    className="w-4 h-4 md:w-6 md:h-6"
                    src={historyPrimary}
                    alt=""
                  />
                ) : (
                  <img
                    className="w-4 h-4 md:w-6 md:h-6"
                    src={historyGray}
                    alt=""
                  />
                )}
              </div>
              <div>
                <h1 className="text-base md:text-[20px]">History</h1>
              </div>
            </div>
            <div
              onClick={() => setPage("referrals")}
              className={`flex items-center space-x-[5px] md:space-x-3 cursor-pointer py-3 ${
                page === "referrals"
                  ? "text-primary font-semibold"
                  : "hover:text-primary text-themeGray font-medium"
              }`}
            >
              <div>
                {page === "referrals" ? (
                  <img
                    className="w-5 h-5 md:w-6 md:h-6"
                    src={referralsPrimary}
                    alt=""
                  />
                ) : (
                  <img
                    className="w-5 h-5 md:w-6 md:h-6"
                    src={referralsGray}
                    alt=""
                  />
                )}
              </div>
              <div>
                <h1 className="text-base md:text-[20px]">Referrals</h1>
              </div>
            </div>
          </div>
        </div>
        <div className="col-span-2 border border-border rounded-lg p-5">
          <div>{page === "wallet" && <Wallet />}</div>
          <div>{page === "history" && <History />}</div>
        </div>
      </div>
    </div>
  );
}
